var map = {
	"./category-10.svg": "42e8",
	"./category-9.svg": "be7b",
	"./category-Adventure.svg": "8624",
	"./category-Biography.svg": "0788",
	"./category-Comedy.svg": "1a91",
	"./category-Drama.svg": "aac7",
	"./category-Fantasy.svg": "b711",
	"./category-Horror.svg": "9e8d",
	"./category-How-to.svg": "8728",
	"./category-Mystery.svg": "2c1f",
	"./category-Romance.svg": "c2a8",
	"./category-Science fiction.svg": "9f3b",
	"./category-Self-help.svg": "84fe",
	"./category-Thriller.svg": "bdd1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1857";